import script from "./EventSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./EventSidebar.vue?vue&type=style&index=0&id=4fcc6a63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fcc6a63"]])

export default __exports__